module.exports = __webpack_public_path__ + "img/full7-min.8980731b.png";